/*
 * @Author: mikey.zhaopeng
 * @Date: 2021-07-05 09:18:40
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-07-06 10:39:08
 */
/**
 * YxInput 公共参数类型约束
 */

import PropTypes from "prop-types";
import { IStyleParam } from "../../../utils/propType";

export const IYxInputPropTypes = {
  //该控件的ID，用于在非受控组件时，进行值的获取,必填项，默认为随机数
  id: PropTypes.string,

  //控件的值
  // value: PropTypes.string,
  // //默认值
  // defaultValue: PropTypes.string,

  //描述、标签
  label: PropTypes.node,

  //input之前的内容
  beforeNode: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  //input之后的内容
  afterNode: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  //默认提示
  placeholder: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),

  //是否为受控，是否为受控组件，默认false，非受控组件会引入from.item
  isControlled: PropTypes.bool,

  //是否禁用
  disabled: PropTypes.bool,

  //from 对象
  from: PropTypes.object,

  //验证规则
  rules: PropTypes.object,

  //直接给fromItem的参数,参考antd 的From.Item
  formItemParam: PropTypes.object,

  //直接给input控件本身设置的参数,参考antd的Input 组件
  inputParam: PropTypes.object,

  //直接给input的getFieldDecorator设置的参数,参考antd 的rc-from
  getFieldDecorator: PropTypes.object,

  //内容改变回调
  change: PropTypes.func,

  // 子节点
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),

  //决定裁掉多少个label文字
  labelLength: PropTypes.number,

  //配置input框的默认限制字符数
  defaultInputMax: PropTypes.number,

  //样式
  styleParam: IStyleParam,
};

export const lableIValueItme = PropTypes.shape({
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.node,
});



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/IpropType/basePropType.js